import ReactDocumentTitle from "../../components/ReactDocumentTitle";
import Layout, {Header, Main} from "../../components/Layout";
import Container from "../../ui/container";
import classes from "./offline-test-sessions.module.css";
import Breadcrumbs from "../../ui/breadcrumbs";
import React, {useCallback, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useQuery} from "@apollo/client";
import OfflineTestSessionsTable from "../../components/account/offline-test-sessions-table/OfflineTestSessionsTable";
import {
  offlineTestSessionsQuery,
  QueryData,
} from "./offline-test-sessions.graphql";

import FullscreenAudio from "../../ui/fullscreenaudio";
import Button from "../../ui/button";
import {useModal} from "../../components/ModalProvider";
import AddOfflineTestSessionModal
  from "../../components/account/offline-test-sessions-table/AddOfflineTestSessionModal";
import CompetenceResultsModal
  from "../../components/account/offline-test-sessions-table/CompetenceResultsModal";
import {OfflineTestSession, CompetenceResult} from "../../schema";
import cn from "classnames";
import {classes as tourClasses} from "../editor/index.tour";
import {AddIcon} from "../../ui/icons";

export default function OfflineTestSessionsScene() {
  const {t} = useTranslation();
  const {add: addModal} = useModal();

  const [sessions, setSessions] = useState<OfflineTestSession[]>([]);
  const [audioSrc, setAudioSrc] = useState<string>();

  const onPlayButtonClick = useCallback((e: React.MouseEvent) => {
    const src = e.currentTarget.getAttribute("data-id");
    setAudioSrc(src ?? undefined);
  }, []);
  const resetAudioSrc = useCallback(() => setAudioSrc(undefined), []);

  const {data, loading: fetching, refetch} = useQuery<QueryData>(offlineTestSessionsQuery);
  const loading = !data && fetching;

  useEffect(() => {
    if (!loading) {
      setSessions(data?.getOfflineTestSessions ?? []);
    }
  }, [loading, data]);

  const handleCreateSession = useCallback(() => {
    const modal = addModal({
      size: "m",
      header: <AddOfflineTestSessionModal.Header />,
      content: (
        <AddOfflineTestSessionModal.Content
          onSuccess={() => {
            modal.remove();
            refetch();
          }}
        />
      ),
    });
  }, [addModal, refetch]);

  const handleCompetenceResultsClick = useCallback((competenceResults: CompetenceResult[]) => {
    addModal({
      size: "m",
      header: <CompetenceResultsModal.Header />,
      content: <CompetenceResultsModal.Content competenceResults={competenceResults} />,
    });
  }, [addModal]);

  return (
    <>
      <ReactDocumentTitle title={t("offlineTestSessions.title")} />

      <Layout>
        <Header />
        <Main>
          <Container className={classes.main}>
            <Breadcrumbs className={classes.breadcrumbs}>
              <span> {t("offlineTestSessions.sessions")}</span>
            </Breadcrumbs>
            <div className={classes.header}>
              <h1 className={classes.h1}>{t("offlineTestSessions.sessions")}</h1>
              <Button color="primary"
                      className={cn(classes.addButton, tourClasses.addProjectButton)}
                      onClick={handleCreateSession}
              >
                <AddIcon/>{t("offlineTestSessions.createSession")}
              </Button>
              {/*<Button*/}
              {/*  className={cn(classes.addButton, tourClasses.addProjectButton)}*/}
              {/*  onClick={onAddProject}*/}
              {/*  color="primary"*/}
              {/*>*/}
              {/*  <AddIcon/>{t("offlineTestSessions.createSession")}*/}
              {/*</Button>*/}
            </div>

            {!loading && sessions && (
              sessions.length > 0 ? (
                <OfflineTestSessionsTable
                  sessions={sessions}
                  onPlayButtonClick={onPlayButtonClick}
                  onCompetenceResultsClick={handleCompetenceResultsClick}
                />
              ) : (
                <div className={classes.emptyState}>{t("offlineTestSessions.emptyState")}</div>
              )
            )}
            {audioSrc && <FullscreenAudio onClose={resetAudioSrc} src={audioSrc} />}
          </Container>
        </Main>
      </Layout>
    </>
  );
}

